import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_ID_OF_STATEMENTS_QUERY = gql`
  query StatementListItemIds($params: StatementListItemsInput!) {
    statementListItems(params: $params) {
      data {
        id
      }
    }
  }
`;
